import { makeStyles } from 'tss-react/mui';
import { red } from '@mui/material/colors';

export default makeStyles()(theme => ({
    errorIcon: {
        fontSize: 200,
        color: red[500]
    },
    paper: {
        padding: theme.spacing(2)
    },
    formControl: {
        display: 'flex',
        alignItems: 'baseline',
        marginBottom: theme.spacing(1) / 2
    },
    leftItem: {
        flex: 1,
        textTransform: 'uppercase'
    },
    rigthItem: {
        flex: 2,
        display: 'flex',
        justifyContent: 'flex-end'
    },
    title: {
        marginBottom: theme.spacing(2)
    },
    media: {
        maxHeight: 250,
        maxWidth: 250,
        '& img': {
            width: 'auto',            
            maxHeight: '100%'
        }
    }
}))